export enum PlanDetailsId {
  BenefitsAndCosts = "benefits",
  DrugCoverage = "drug-coverage",
  ExtraBenefits = "extra-benefits",
  MaxYouPay = "max-you-pay",
  OptionalPackages = "optional-packages",
  Overview = "overview",
  PlanDocuments = "plan-documents",
  PlanInfo = "plan-details-plan-info",
  Providers = "providers",
  StarRatings = "star-ratings",
}
